import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreatePortAgentComponent } from './create-port-agent.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    CreatePortAgentComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
  ],
  exports:[
    CreatePortAgentComponent
  ]
})
export class CreatePortAgentModule { }
